import React from 'react'
import { MdOutlineScreenSearchDesktop } from 'react-icons/md';
import { VscRecord } from 'react-icons/vsc';
import { BsHash, BsStack, BsFillPeopleFill } from 'react-icons/bs';
import { HiUserRemove } from 'react-icons/hi';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import { ProSidebar, Menu, MenuItem, SidebarContent, SidebarHeader } from "react-pro-sidebar";
import HistoryTwoToneIcon from '@mui/icons-material/HistoryTwoTone';
import { FaChalkboardTeacher } from "react-icons/fa";

const ApplicantSideBar = ({ setActive, active, data }) => {



	// Filter data for different application statuses
	const screening = data?.data?.screenedApplications;
	const applicant = data?.data?.pendingApplications;// Objects with application status "APPLIED"
	const offered = data?.data?.offeredApplications; // Objects with application status "OFFERED"
	const hired = data?.data?.hiredApplications; // Objects with application status "HIRED"
	const dropout = data?.data?.droppedApplications; // Objects with application status "DROPOUT" 
	const evaluation = data?.data?.evaluatedApplications; // Objects with application status "EVALUATION"
	const interview = data?.data?.pendingInterviews;
	const interviewHistory = data?.data?.completedInterviews;
	const tranning = data?.data?.tranning;

    
	const ApplicantSidebarList = [
		{ title: "New", icon: <VscRecord size={25} />, metric: !applicant ? "0" : applicant },
		{ title: "Screening", icon: <MdOutlineScreenSearchDesktop size={25} />, metric: !screening ? "0" : screening },
		{ title: "Evaluating", icon: <BsFillPeopleFill size={25} />, metric: !evaluation ? "0" : evaluation },
		{ title: "Interviews", icon: <VideoCameraFrontIcon fontSize="medium" />, metric: !interview ? "0" : interview },
		{ title: "Interview History", icon: <HistoryTwoToneIcon fontSize="medium" />, metric: "" },
		{ title: "Offered", icon: <BsStack size={20} />, metric: !offered ? "0" : offered },
		{ title: "Training", icon: <FaChalkboardTeacher size={25} />, metric: !tranning ? "0" : tranning },
		{ title: "Hired", icon: <BsHash size={25} />, metric: !hired ? "0" : hired },
		{ title: "Dropouts", icon: <HiUserRemove size={25} />, metric: !dropout ? "0" : dropout },
	]

     



	return (
		<div id='Sidenavbar'>
			<div id='SideBar__container'>
				<div className='SideBar__content'>
					<ProSidebar >
						<SidebarHeader>
							<h4>Applicants</h4>
						</SidebarHeader>
						<SidebarContent>
							<Menu>
								{ApplicantSidebarList?.map((item, index) => (
									<MenuItem
										key={index}
										className='Side__Content'
										active={index === active}
										icon={item.icon}
										suffix={item.metric}
										onClick={() => {
											setActive(index);
											localStorage.setItem('active', index.toString());
										}}
									>
										{item.title}
									</MenuItem>
								))}
							</Menu>
						</SidebarContent>
					</ProSidebar>
				</div>
			</div>
		</div >
	)
}

export default ApplicantSideBar